import React from "react";
import "./style.scss";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";

const AccountActivatedDetails: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <article className="">{t("od_teraz_mozesz_korzystac_z_kolejnych_odogodnien")}</article>

      <ul>
        <li>
          <span>{t("dostep_do_rachunkow_dokumentow")}</span>
        </li>
        <li>
          {" "}
          <span>{t("dostep_do_wykupionych_biletow")}</span>
        </li>
        {saleConfiguration.passSaleActive && (
          <li>
            <span>{t("dostep_do_wykupionych_karnetow")}</span>
          </li>
        )}
        {saleConfiguration.allowReservationByPassOnFitnessPlan && (
          <li>
            <span>{t("mozliwosc_zapisu_sie_karnetem_na_zajecia")}</span>
          </li>
        )}
        {saleConfiguration.calendar_AllowPassChange && (
          <li>
            <span>{t("zarzadzenie_wieloma_karnetami")}</span>
          </li>
        )}
        {saleConfiguration.allowReservedExerciseChange && (
          <li>
            <span>{t("mozliwosc_zmiany_terminu_realizacji_biletow")}</span>
          </li>
        )}
        {saleConfiguration.ecard_PayByEcard && (
          <li>
            <span>
              {t("mozliwosc_placenia_nasza")} {saleConfiguration.giftCard3Message}
            </span>
          </li>
        )}
        {saleConfiguration.ecard_RegisterIncome && (
          <li>
            <span>
              {t("mozliwosc_doladowania_naszej")} {saleConfiguration.giftCard1Message}
            </span>
          </li>
        )}
        {saleConfiguration.newsLetterActive && (
          <li>
            <span>{t("mozliwosc_zapisu_na_newsletter")}</span>
          </li>
        )}
      </ul>
    </React.Fragment>
  );
};

export default AccountActivatedDetails;
